import { IDiscoverRedesignPhase3XP } from "@faire/web-api/com/faire/search/IDiscoverRedesignPhase3XP";

import { useSettingDiscoverRedesignPhase3XP } from "@faire/retailer/settings/useSettingDiscoverRedesignPhase3XP";

export const useIsDiscoverRedesignPhase3XP = (): boolean => {
  const settingDiscoverRedesignPhrase3XP = useSettingDiscoverRedesignPhase3XP();
  return (
    settingDiscoverRedesignPhrase3XP !==
    IDiscoverRedesignPhase3XP.Bucket.CONTROL
  );
};
